import AppLayout from "@/layouts/AppLayout.vue";
import SupportListView from "@/views/support/SupportListView.vue";
import SupportTicketDetailView from "@/views/support/SupportTicketDetailView.vue";

export default [
  {
    path: '/support',
    name: 'supportTickets',
    component: SupportListView,
    meta: {
      parent: 'support',
      related: 'supportTickets',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['GET_SUPPORT_TICKET']
    }
  },
  {
    path: '/support/:ticketId',
    name: 'supportTicketDetail',
    component: SupportTicketDetailView,
    props: true,
    meta: {
      parent: 'support',
      related: 'supportTickets',
      layout: AppLayout,
      requiresAuth: true,
      inNav: false,
      permissions: ['GET_SUPPORT_TICKET']
    }
  },
];
